module.exports = __webpack_public_path__ + "modern-white.png";